import { AddPaymentPayload } from 'gb-dashboard/checkout/data-access-payments'
import { DashboardPaymentEntity } from 'libs/gb-dashboard/checkout/data-access-payments/src/lib/+state/payments.models'
import {
  BaseEventTicketEntity,
  EventTicketPurchaserEntity,
} from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'
import { BaseSlimEventTicketPackageEntity } from 'libs/shared/models/event-tickets/event-ticket-packages.models'

export const ticketPuchasesEntityName = 'TicketPurchases'
export const INITIAL_EVENT_TICKET_PURCHASE_ORDERING = '-refunded,-created'

export interface EventTicketPurchasesEntity {
  apply_fee: string | null
  auction: string
  created: string
  discount_code: string | null
  discount_type: string | null
  discount_value: string | null
  discount_quantity: number | null
  payment: DashboardPaymentEntity | null
  payment_pending: boolean | null
  profile: EventTicketPurchaserEntity
  quantity: number
  refunded: string | null
  refunded_quantity: number
  request_invoice_pending: boolean
  stripe_card: string | null
  subtotal: string
  tax_label: string | null
  tax_method: string | null
  tax_rate: string | null
  total: string
  total_tax: string
  ticket_package: SlimEventTicketPackageEntity
  ticket_package_price: number
  uuid: string
  tickets: BaseEventTicketEntity[]
}

export interface EventTicketPurchasePayload extends AddPaymentPayload {
  quantity: number
  ticket_package: { uuid?: string }
}

export type SlimEventTicketPackageEntity = BaseSlimEventTicketPackageEntity

export interface RefundEventTicketPurchaseResult {
  reason: string
  tickets?: string[]
}

export const EVENT_TICKET_PURCHASES_LOADER = {
  refundPurchase: {
    id: 'refundPurchase',
  },
  issuePurchase: {
    id: 'issuePurchase',
  },
}
